import { api } from '@/lib/axios';

export interface SamplingBlockReason {
  id: number;
  name: string;
}

export const fetchSamplingBlockReasons = async (): Promise<SamplingBlockReason[]> => {
  try {
    const { data } = await api.get<SamplingBlockReason[]>('/api/sampling-block-reasons');
    return data;
  } catch (error) {
    console.error('Error fetching sampling block reasons:', error);
    throw new Error('Error al cargar los motivos de bloqueo de muestreo');
  }
}; 